import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { PageHeader } from '@egw/components'
import { WealthDisclosures } from '@egw/features-system'
import { Statements as StatementsComponent } from '../../components/statements/statements'
import { Legal } from '../../components/legal/legal'
import { TradeConfirmations } from '../../components'
import { Tax } from '../../components/tax/tax'

export const Documents: FC = () => {
  const { t } = useTranslation('features-documents')

  return (
    <>
      <PageHeader title={t('common.title')} />
      <div className="egw-container pt-0">
        <StatementsComponent />
        <TradeConfirmations />
        <Tax />
        <Legal />
        <WealthDisclosures showCheckingDisclosure className="mt-lg" />
      </div>
    </>
  )
}
